import { InputGroup, InputRightElement, Input } from '@chakra-ui/react';
import { forwardRef } from 'react';
import React from 'react';
import CalendarIcon from '../../icons/CalendarIcon/CalendarIcon';
import { useTokens } from '../../../context/TokenProvider';
const DateTimePickerCustomInput = forwardRef((props, ref) => {
    const tokens = useTokens();
    return (React.createElement(InputGroup, null,
        React.createElement(Input, { ref: ref, onClick: props.onClick, ...props, "data-testid": "date-time-picker-custom-input" }),
        React.createElement(InputRightElement, { opacity: props.isDisabled ? tokens.Opacity04 : undefined, cursor: !props.isDisabled ? 'pointer' : undefined, onClick: props.onClick, h: "100%" },
            React.createElement(CalendarIcon, null))));
});
export default DateTimePickerCustomInput;
